import { render, staticRenderFns } from "./TabSwitch.vue?vue&type=template&id=0ccf29e9&scoped=true&"
import script from "./TabSwitch.vue?vue&type=script&lang=js&"
export * from "./TabSwitch.vue?vue&type=script&lang=js&"
import style0 from "./TabSwitch.vue?vue&type=style&index=0&id=0ccf29e9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccf29e9",
  null
  
)

export default component.exports